import { makeAutoObservable } from "mobx";
import { EntityRepository } from "@/app_store/stream/entity_repository";


export interface DeploymentService {
    id: string;
    account_id: string;
    name: string;
    environment: string;
    status: string;
    updated_at: string | number;
    is_deleted?: boolean;
}


export class DeploymentServiceStore {
    repository = new EntityRepository<DeploymentService>("id");

    constructor() {
        makeAutoObservable(this, { repository: false });
    }

    get all(): DeploymentService[] {
        return this.repository.active.map(e => e.value);
    }

    get devServices(): DeploymentService[] {
        return this.all.filter(s => s.environment === "dev");
    }

    get prodServices(): DeploymentService[] {
        return this.all.filter(s => s.environment === "prod");
    }

    servicesByEnv(env: string): DeploymentService[] {
        return this.all.filter(s => s.environment === env);
    }
}
